/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/* eslint-disable */
window.PXUTheme.jsHeader = {
  init: function($section) {
    // Add settings from schema to current object
    window.PXUTheme.jsHeader = $.extend(this, window.PXUTheme.getSectionData($section));

    // Selectors
    this.$el = $('#header')
    this.$menuToggle = this.$el.find('.header__menu-toggle');
    let announcementHeight = $('.announcement-sticky-wrapper').height();

    // Overlaid header
    if (this.enable_overlay === true && isScreenSizeLarge()) {
      this.updateOverlayStyle(this.sectionUnderlayIsImage());
    }

    // Sticky header
    if (this.enable_sticky === true && isScreenSizeLarge()) {
      this.enableSticky(announcementHeight);
      $(window).on('resize', () => {
        this.enableSticky(announcementHeight);
      });
    }

    if (this.header_layout == 'centered' || this.header_layout == 'search_focus') {
      this.$menuToggle.on('click', () => {
        this.showStickyMenu();
      })
    } else if (this.header_layout == 'vertical') {
      $section.find('.header-sticky-wrapper').stick_in_parent();
      this.addOffScreenDropdownCheck();
    }

    if ($('.mega-menu').length > 0) {
      window.PXUTheme.jsMegaMenu.init($section);
    }

    if(!isScreenSizeLarge()) {
      this.unload();
      window.PXUTheme.mobileMenu.init();
    }

    $('.search-overlay__close').on('click', function(){
      window.PXUTheme.jsHeader.hideSearch();
    });

    $(document).on('click',  '[data-show-search-trigger]', function(){
      window.PXUTheme.jsHeader.showSearch();
    });

    if (isScreenSizeLarge() || !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      $('.dropdown-click--true .header__link:not(.primary-brand, .primary-logo)').on('click touchstart', function(e) {
        var $this = $(this);
        window.PXUTheme.jsHeader.toggleMenuClick(e, $this);
      });
    }

    if (this.dropdown_click === false) {
      $('.navbar-item').on('mouseleave', function(){
        window.PXUTheme.jsHeader.collapseSubmenu($(this));
      });
    }

    $(document).on('keydown', '[data-show-search-trigger]', function(e) {
      if (e.which === 13) {
        window.PXUTheme.jsHeader.showSearch();
      }
    });

    if (window.PXUTheme.theme_settings.search_layout == 'overlay') {
      document.body.addEventListener('click', e => {
        if (e.target === document.querySelector('[data-site-overlay]')) {
          window.PXUTheme.jsHeader.hideSearch();
        }
      });
    }
  },
  toggleMenuClick: function(e, $this) {
    var $parentWrap = $this.parents('.has-dropdown, .has-mega-menu');

    if (!$parentWrap.hasClass('is-opened') && $parentWrap.length > 0) {
      // Prevent link on first click
      e.preventDefault();

      // Close all dropdowns & mega menu
      $('.has-dropdown, .has-mega-menu').removeClass('is-opened');
      $('.mega-menu__section').removeClass('is-active');

      // Open selected dropdown/mega menu
      $parentWrap.addClass('is-opened');
      $parentWrap.data('clicked', 'true');
    } else {

      // Close all dropdowns & mega menu
      $('.has-dropdown, .has-mega-menu').removeClass('is-opened');
      $('.mega-menu__section').removeClass('is-active');
    }

    // Close dropdown if click anywhere outside dropdown menu
    $(window).on('click', function(e) {
      if ($(e.target).closest('.header__link, .navbar-dropdown').length === 0) {
        $('.has-dropdown, .has-mega-menu').removeClass('is-opened');
        $('.mega-menu__section').removeClass('is-active');
        window.PXUTheme.jsHeader.collapseSubmenu($('.navbar-item'));
      }
    });
  },
  collapseSubmenu: function(el) {
    $(el).find('.has-submenu input').prop("checked", false);
  },
  showStickyMenu: function() {
    this.$menuToggle.toggleClass('is-active');
    this.$el.find('.sticky-menu-wrapper').toggleClass('is-visible');
  },
  hideStickyMenu: function() {
    this.$menuToggle.removeClass('is-active');
    this.$el.find('.sticky-menu-wrapper').removeClass('is-visible');
  },
  disableSticky: function() {
    let $stickyEl = $('#header');

    $stickyEl.unstick();
    $stickyEl.removeClass('sticky--enabled');

    setTimeout(function(){
      $stickyEl.css('height', 'auto');
    }, 250)
  },
  enableSticky: function(offset){
    let $stickyEl = this.$el;

    $stickyEl.addClass('sticky--enabled');

    $stickyEl.sticky({
      wrapperClassName: 'header-sticky-wrapper',
      zIndex: 70,
      topSpacing: offset || 0
    })
    .on('sticky-start', () => {
      let headerHeight;
      let announcementHeight;

      // Hide the mini cart for centered header layout
      if(window.PXUTheme.theme_settings.header_layout == 'centered') {
        $('.top-bar [data-ajax-cart-trigger] [data-ajax-cart-mini_cart]').css('display', 'none');
      }

      // Get header height is sticky enabled
      if(window.PXUTheme.jsHeader.enable_sticky == true && window.PXUTheme.theme_settings.header_layout != 'vertical') {
        headerHeight = window.PXUTheme.jsHeader.getHeaderHeight();
      }

      // Get announcement height is sticky enabled
      if(typeof window.PXUTheme.jsAnnouncementBar !== 'undefined' && window.PXUTheme.jsAnnouncementBar.enable_sticky == true && window.PXUTheme.theme_settings.header_layout != 'vertical') {
        announcementHeight = window.PXUTheme.jsAnnouncementBar.getAnnouncementHeight();
      } else {
        announcementHeight = 0;
      }

      let totalHeight = headerHeight + announcementHeight;
      $stickyEl.parent().parent().find('.search-overlay').addClass('sticky-search').css('top', totalHeight + 'px');

      if (this.enable_overlay === true && this.sectionUnderlayIsImage() === true)  {

        $stickyEl.parent().addClass('has-overlaid-header');
        this.disableOverlayStyle();

      } else if (this.enable_overlay === true) {

        this.disableOverlayStyle();

      }
    })
    .on('sticky-end', () => {
      $stickyEl.parent().parent().find('.search-overlay').removeClass('sticky-search').css('top', '100%');

      // Safety timeout for logo width transition which can throw calculated height off
      setTimeout(() => {
        $stickyEl.sticky('update');
      }, 250);

      // Un-hide the mini cart when scrolled back to the top
      if(window.PXUTheme.theme_settings.header_layout == 'centered') {
        $('.top-bar [data-ajax-cart-trigger] [data-ajax-cart-mini_cart]').css('display', 'block');
      }

      this.$el.find('.sticky-menu-wrapper').removeClass('is-visible');
      this.$menuToggle.removeClass('is-active');

      if (this.enable_overlay === true && this.sectionUnderlayIsImage() === true) {
        this.updateOverlayStyle(this.sectionUnderlayIsImage());
      }
    })
  },
  disableOverlayStyle: function() {
    $('[data-enable_overlay]').attr('data-enable_overlay', true);
  },
  enableOverlayStyle: function() {
    $('[data-enable_overlay]').attr('data-enable_overlay', true);
  },
  updateOverlayStyle: function(overlayBoolean) {
    $('[data-enable_overlay]').attr('data-enable_overlay', true);
  },
  sectionUnderlayIsImage: function() {

    let $firstSection = $('[data-check-for-order=true]').find('[id^=shopify-section]').first();

    // Check whether the first element has class to indicate it should be under header when overlay is enabled
    if ($firstSection.hasClass('overlaid-header-option') && $.trim($firstSection.html()).length > 0) {
      return true;
    } else {
      return false;
    }

  },
  showSearch: function() {
    $('[data-show-search-trigger]').addClass('is-active');

    if(window.PXUTheme.theme_settings.search_layout == 'overlay') {
      $('[data-search-type="overlay"]').addClass('is-opened');
      $('.search-form .search__fields input[type="text"]')[0].focus();
      window.PXUTheme.predictiveSearch.lockBodyScroll();
    } else {
      $.fancybox.open($('.js-search-popup'), {
        baseClass: 'search__lightbox',
        hash: false,
        infobar : false,
        toolbar: false,
        loop: true,
        smallBtn : true,
        mobile: {
          preventCaptionOverlap: false,
          toolbar: false,
        },
        touch: false,
        beforeClose: function(){
          $('[data-show-search-trigger]').removeClass('is-active');
        },
        afterShow: function() {
          // Set the cursor at the end of the input field for better UX,
          // otherwise it may be at the beginning of the input field when the input gets focus.
          const searchInputEl = $('.search-form .search__fields input[type="text"]')[0];
          const searchTermLength = searchInputEl.value.length;
          searchInputEl.setSelectionRange(searchTermLength, searchTermLength);
        },
      })
    }
  },
  hideSearch: function() {
    $('[data-show-search-trigger]').removeClass('is-active');
    if(window.PXUTheme.theme_settings.search_layout == 'overlay' || window.PXUTheme.theme_settings.header_layout == 'search_focus' || window.PXUTheme.theme_settings.header_layout == 'vertical') {
      $('[data-autocomplete-true] .search__results-wrapper').hide();
      $('[data-search-type="overlay"]').removeClass('is-opened');
      window.PXUTheme.predictiveSearch.unlockBodyScroll();
    } else {
      $.fancybox.close($('[data-search-type="'+window.PXUTheme.theme_settings.search_layout+'"]'));
    }
  },
  addOffScreenDropdownCheck: function() {
    $('.navbar-item.has-dropdown--vertical').hover(function() {

      const dropdown = $(this),
      menu = dropdown.find('.navbar-dropdown');

      menu.removeClass('navbar-dropdown--fix-offscreen');

      if (menu.is(':off-screen')) {
        menu.addClass('navbar-dropdown--fix-offscreen');
      }

      });
  },
  getHeaderHeight: function() {
    const headerHeight = $('.header-section').outerHeight() || 0;


    return headerHeight;
  },
  unload: function($section) {
    $('.has-overlaid-header').removeClass('has-overlaid-header');
    $('[data-show-search-trigger]').off();
    $('.navbar-item').off();
    $('#header').off();
    $('.dropdown-click--true .header__link').off();
    this.$menuToggle.off();
    this.disableSticky();
    this.disableOverlayStyle();
  }
}

/******/ })()
;

// $(".mega-menu-images .child-includes:first-child").parent().addClass("active")
$(".mega-menu-images.layout_1").each(function(){
    var GetChildren = $(this).children();
    $(GetChildren).each(function(){
      if($(this).children().length == 0){
        $(this).remove()
      }
    })
})
setTimeout(function(){
$(".mega-menu-images.layout_1").each(function(){
    var ActiveChildren = $(this).children();
    ActiveChildren.first().addClass("active");
})
}, 1000);
$(".navbar-item.menu__heading,.navbar-item.no-sub-link").on("mouseover",function(){
  var $dataOverlink = $(this).attr("data-linkhandle");
  var $selectedClass = ".main-"+$dataOverlink;
  $(this).parent(".horizontal-dropdown__column").siblings().removeClass("active"); 
  $(this).parent(".horizontal-dropdown__column").addClass("active");
  if($($selectedClass).length > 0){
    $($selectedClass).parents(".mega-menu-images").children(".collection-images").removeClass("active")
    $($selectedClass).parent().addClass("active");
  }
})
var $loadSrc = $(".megamenu-layout_2 .navbar-submenu .navbar-item:first-child").attr("data-src");
var $loaddiscription = $(".megamenu-layout_2 .navbar-submenu .navbar-item:first-child").attr("data-discription");
if($loadSrc != "" || $loaddiscription != ""){
    $(".mega-menu-images.layout_2 .append_colelction-img img").attr("src",$loadSrc);
    $(".mega-menu-images.layout_2 .append_colelction-img p.collection-discription").html($loaddiscription);
  }
$(".megamenu-layout_2 .navbar-submenu .navbar-item").on("mouseover",function(){
  var $dataOverlink = $(this).attr("data-src");
  var $dataDIscription = $(this).attr("data-discription");
  if($dataOverlink != ""){
    $(".mega-menu-images.layout_2 .append_colelction-img img").attr("src",$dataOverlink);
    $(".mega-menu-images.layout_2 .append_colelction-img p.collection-discription").html($dataDIscription);
  }
});

/* MG 27 Jul 2026 (V8): mega-menu gap fix. utilities.js binds .hover() directly to each
   .has-dropdown--horizontal item and removes body.dropdown-visible / html.scroll-locked
   the INSTANT the pointer leaves that specific item -- with no regard for whether the
   pointer is still inside .header__menu-items (e.g. crossing a plain link like "New"
   between Makers and Collections). Once dropdown-visible drops, mg-tweaks.css's
   CLOSED rule has no body.dropdown-visible gate, so it falls back to the long delayed
   transition (visibility 0s linear calc(--mg-mm-expand 920ms + --mg-mm-closedelay 300ms))
   -- meaning the panel you just left (Makers) stays VISIBLE, painted on top of whatever
   opens next (it is later in the DOM), for up to ~1.2s. That's the "delay of about a
   second" Will reported when moving Makers -> Collections (or any two dropdown items
   with a non-dropdown item like "New" between them). Shop -> Collections feels instant
   only because they're adjacent -- there's no gap item to dwell on, so leave+re-enter
   happen in the same tick and dropdown-visible never really drops.
   Fix: as long as the pointer is still anywhere inside .header__menu-items, re-apply
   dropdown-visible/scroll-locked immediately after utilities.js removes them (this
   handler is delegated on the row, so it runs right after utilities.js's direct handler
   on the item, same synchronous tick -- no flicker). The item that was just left still
   loses its OWN :hover/.active, so its panel correctly goes visibility:hidden INSTANTLY
   (the mg-tweaks.css "dropdown-visible but not hover/active" rule uses a 0s transition,
   unlike the no-dropdown-visible fallback) -- so Makers' panel now disappears cleanly
   instead of ghosting on top. True close (pointer leaves the WHOLE row) is unaffected --
   handled by the second listener below, which does the full cleanup utilities.js used to
   own alone. Additive; does not modify utilities.js or mg-tweaks.css. Desktop-only in
   practice (no hover on touch). To revert: delete this trailing block. */
(function(){
  var $row = $('.header__menu-items');
  if (!$row.length) return;

  $row.on('mouseleave', '.navbar-item.has-dropdown--horizontal', function(){
    if ($row.is(':hover')) {
      $('body').addClass('dropdown-visible');
      $('html').addClass('scroll-locked');
    }
  });

  $row.on('mouseleave', function(){
    $('body').removeClass('dropdown-visible');
    $('html').removeClass('scroll-locked');
    $('.navbar-item.has-dropdown--horizontal').removeClass('active').removeClass('mg-warmed');
    $('.horizontal-dropdown__column').removeClass('active');
  });
})();

/* MG 27 Jul 2026 (V8), SESSION 3: "warmed" tracking, paired with mg-tweaks.css. Will
   reported that moving the cursor laterally within the header (e.g. Shop -> Collections)
   opened the mega-menu instantly/snapped open, whereas hovering up into a menu fresh
   from the main page played the proper reveal. Root cause: mg-tweaks.css's "dropdown-
   visible, not hover/active" rule (and the now-removed 25-Jul hold-hack) forced every
   dropdown item's clip-path open the moment ANY part of the header row was hovered --
   including items never actually visited yet -- so they were silently pre-opened in the
   background and simply snapped into view with no reveal when you landed on them.
   Fix: mark an item .mg-warmed the instant it's genuinely entered (mouseenter, delegated
   on the row). mg-tweaks.css's "not hover/active" rule now requires .mg-warmed, so an
   item that hasn't been warmed this visit no longer gets its clip-path force-opened by
   that rule -- it falls through to the true base CLOSED rule regardless of what the rest
   of the row is doing, so it always plays the full clean reveal the first time you land
   on it (identical to hovering up from the main page). Once warmed it stays fast for the
   rest of the browsing session. Cleared on true row-exit (above) so a fresh approach
   later gets the full reveal again too. To revert: delete this block (and drop the
   .mg-warmed requirement + .removeClass('mg-warmed') added elsewhere for this fix). */
/* MG 27-28 Jul 2026 (V8), SESSION 6: pre-warm siblings on first engagement. Will reported
   that swapping Shop -> Collections still showed the slide-reveal the FIRST time this
   session (Collections had never been individually warmed), and only became instant on
   later swaps once Collections itself had been visited once. Per-item warming above only
   marks the item you actually enter, on enter -- it can't retroactively change the clip-
   path STARTING value for that same entry's own transition (the browser interpolates from
   whatever the item's resolved style was on the previous frame, which for a never-warmed
   item is the true closed rule regardless of when mg-warmed gets added in the same tick),
   so a lateral swap into a never-before-visited sibling still played the full reveal even
   though you were already mid-session with another item open right next to it.
   Fix: the moment the FIRST item of a fresh engagement is entered (tracked with our own
   sessionEngaged flag rather than reading body.dropdown-visible, to sidestep any race with
   utilities.js's own direct hover binding), warm ALL sibling dropdown items in that same
   tick too -- not just the one actually being hovered. The entered item still plays its
   own full reveal correctly (warming it doesn't touch its own already-in-flight
   transition), but every sibling's clip-path is now sitting pre-opened-but-hidden per
   mg-tweaks.css's warmed/not-hover rule, so swapping to ANY of them next -- even ones
   never individually visited before -- is instant. Matches "the mm stays in place and
   works fine" for every swap after the very first item of a session. Reset alongside the
   existing full-row-exit cleanup so a later fresh approach plays the reveal again. */
(function(){
  var $row = $('.header__menu-items');
  if (!$row.length) return;
  var sessionEngaged = false;

  $row.on('mouseenter', '.navbar-item.has-dropdown--horizontal', function(){
    $(this).addClass('mg-warmed');
    if (!sessionEngaged) {
      sessionEngaged = true;
      $row.find('.navbar-item.has-dropdown--horizontal').addClass('mg-warmed');
    }
  });

  $row.on('mouseleave', function(){
    sessionEngaged = false;
  });
})();

/* MG 28 Jul 2026 (V8), SESSION 7: body.mg-mm-holding -- paired with mg-tweaks.css's
   session-7 rewrite of the header colour/fill/background/border transition rules. Those
   rules used to treat "neither dropdown-visible nor is-sticky" as a single default state
   and gave it the long var(--mg-mm-headerhold)-delayed transition -- but that state
   covers TWO different situations (closing the mm at the top of the page, which WANTS
   the slow hold; and simply scrolling back out of sticky, which doesn't), so ordinary
   scrolling was incorrectly inheriting the slow hold too, causing a flicker/lag (see
   mg-tweaks.css session-7 comment for the full root-cause writeup). CSS can't
   distinguish these two cases by itself; this class is the JS-driven signal that does.
   Added the moment a dropdown item opens while genuinely at the top of the page (not
   sticky) -- covers the whole time the mm is open there -- and removed automatically
   ~1.7s after the row is left (long enough for the held colour/fill/bg/border transition
   to fully finish, so the class is never pulled mid-fade and can't cause a visible snap).
   Never added at all while sticky, and mg-tweaks.css's mg-mm-holding rules are additionally
   scoped :not(.is-sticky) as a second safety net, so this can never leak into ordinary
   scrolling even if the timeout hasn't fired yet. To revert: delete this block (and the
   four body.mg-mm-holding rules in mg-tweaks.css, restoring their old unscoped base
   selectors as the ones carrying the delayed transition). */
(function(){
  var $row = $('.header__menu-items');
  if (!$row.length) return;
  var holdTimer = null;

  $row.on('mouseenter', '.navbar-item.has-dropdown--horizontal', function(){
    if (!$('.header-sticky-wrapper').hasClass('is-sticky')) {
      clearTimeout(holdTimer);
      $('body').addClass('mg-mm-holding');
    }
  });

  $row.on('mouseleave', function(){
    clearTimeout(holdTimer);
    holdTimer = setTimeout(function(){
      $('body').removeClass('mg-mm-holding');
    }, 1700);
  });
})();
